import { mapActions } from 'vuex';
import datepicker from 'vuejs-datepicker';
import moment from 'moment';
import { GET_BROKER_PRODUCT, UPSERT_BROKER_PROMOTION} from '@/store/actions.type'

export default {
    props: ["cancelModal", "selectedPromoData", "isNewPromocode"],
    data () {
        return {
            msipromotionsloading: true,
            promotionId: this.$route.params.promotionId,
            msiPromotion: {},
			disabledDates: { 
				to: moment().subtract(1, 'days').toDate() 
            },
            checkedNames: [],
            showchecklist: false,
            brokerProducts: [],
            finalAmount: 0,
            originalAmount: 299,
        }
    },

    created () {
        this.getBrokerProduct()
        this.basicPriceUpdateForCalculation()   
        

    },

    computed: {
        getUserDetails () {
            return this.$store.state.authentication.user;
        }
    },

    components: {
        datepicker
    },

    methods: {
        ...mapActions({
            getbrokerproduct: GET_BROKER_PRODUCT,
            upsertbrokerpromotion: UPSERT_BROKER_PROMOTION
          }),

        async getBrokerProduct () {

            await this.getbrokerproduct(this.getUserDetails.isBrokerAdminUser).then(data => {
                this.brokerProducts = data
            })
        },

        async basicPriceUpdateForCalculation () {
            if (!this.isNewPromocode) {
                this.originalAmount = this.selectedPromoData.amount;
                this.discountAmountCalculation()
            }
        },

        async upsertPromo() {
            this.$validator.validateAll().then(async (result) => {

                if (result) {
                    let params = {
                        id: 0,
                        promo: this.selectedPromoData.promo, 
                        description: this.selectedPromoData.description, 
                        productId: this.selectedPromoData.productId, 
                        percentage: this.selectedPromoData.percentage, 
                        startDate: this.selectedPromoData.startDate, 
                        endDate: this.selectedPromoData.endDate, 
                        isAccessPromo: 0, 
                        accessDays: 0, 
                        isActive: this.selectedPromoData.isActive, 
                        usageLimit: this.selectedPromoData.usageLimit,
                        userType: this.getUserDetails.userType
                        }
        
                    if (this.isNewPromocode) {
                        //Add new promo code
                        params.id = 0
                    }
                    else {
                        //Update existing promo code
                        params.id = this.selectedPromoData.id
                    }
        
                    await this.upsertbrokerpromotion(params).then(success => {
        
                        if (success == 1) {
                            this.close(success)
                        }else {
                            this.showAlert()
                        }
                       
                    })
                }
            })
        },

        showAlert() {
            if (this.isNewPromocode) {
                alert("Promo already exists")
            }
            else {
                alert("Something went wrong")
            }
        },

        customDateFormatter(date) {
			return moment(date).format('YYYY-MM-DD');
		},

        close(success) {
            this.cancelModal(success);
        },

        discountPercentageCalculation() {
            if (this.finalAmount > 0) {
                let discountAmount = (this.originalAmount - this.finalAmount);
                this.selectedPromoData.percentage = 100 * discountAmount / this.originalAmount
                return this.selectedPromoData.percentage.toFixed(3)
            }
            
        },

        discountAmountCalculation () {
            if (this.selectedPromoData.percentage > 0) {
                let discount = this.selectedPromoData.percentage;
                let discountAmount = (this.originalAmount * discount / 100);
                this.finalAmount = (this.originalAmount - discountAmount).toFixed(0);
                return this.finalAmount
            }
        },
    }
}


// WEBPACK FOOTER //
// ./src/assets/js/AddPromo.js